<template>
  <div>
    <div class="logo-wrap">
      <div><img :src="logo" alt=""></div>
      <div class="line"></div>
      <div><span>{{config.registeredServiceName||'统一身份认证'}}</span></div>
    </div>
  </div>
</template>
<script>
export default {
  props: [
    'i18n',
    'config',

    'logo'
  ],
  data: function data() {
    return {
    }
  },
  created: function created() {
  },
  mounted: function mounted() {
  },
  methods:{
  }
}
</script>
